<canvas id="stage" class="contact-bar" #canvas></canvas>
  <!-- (mousedown)="mouseDown($event)"
  (mouseup)="mouseUp($event)"
  (mousemove)="coordinates($event)" -->